import { Box, Button, Chip, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Network from './network/Network';
import instId from './network/instituteId';
import { useNavigate } from 'react-router-dom';
import parse from "html-react-parser";
import Endpoints from './network/endpoints';

const TestSeriesSection = ({ endpointsUrl }) => {

    const isMobile = useMediaQuery("(min-width:600px)");
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const navigate = useNavigate();
    const [coursesList, setCoursesList] = useState([]);

    useEffect(() => {
        getAllCourses();
    }, []);

    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses;
        const filterCourses = course?.filter((item) =>
            item?.active === true &&
            ["CA Foundation", "CA Inter", "CA Final"].includes(item?.title)
        );
        setCoursesList(filterCourses);
    };

    const handleCourseClick = (value) => {
        navigate('/course-content', { state: { data: value } })
    }

    return (
        <div style={{ paddingLeft: isMobile ? '6rem' : '1rem', paddingRight: isMobile ? '6rem' : '1rem', paddingTop: isMobile ? '3rem' : '1rem', paddingBottom: isMobile ? '3rem' : '1rem', position: "relative", background: "#00246080" }}>
            <Grid container spacing={2} display={isMobile ? 'flex' : 'none'} justifyContent={'space-between'} alignItems={'center'}>
                {
                    coursesList?.length > 0 && coursesList?.map((item, i) => {
                        return (<Grid item xs={12} sm={4} md={4} lg={4} key={i} direction={'column'}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            sx={{
                                // background: '#E6EAEE',
                                borderRadius: '10px',
                                padding: '1rem',
                                width: '100%',
                                maxWidth: '370px',
                                cursor: 'pointer',
                                // ":hover": {
                                //     background: '#002460',
                                //     boxShadow: 'rgba(0, 0, 0, 0.15) 6.95px 5.95px 4.6px'
                                // },
                                // paddingBottom: '30px'
                            }}
                        >
                            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} onClick={() => handleCourseClick(item)}>
                                <img
                                    src={item?.logo ? endpointsUrl + item?.logo : "img/folder-2.png"}
                                    className="hover-image"
                                />
                            </Box>

                        </Grid>

                        )
                    })
                }
            </Grid>
            {
                coursesList?.length > 0 && coursesList?.map((item, i) => {
                    return (
                        <Stack direction={'column'} spacing={2} display={isMobile ? 'none' : ''} justifyContent={'space-between'} alignItems={'center'} position={'relative'}>
                            <Stack direction={'column'} spacing={2}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                sx={{
                                    // background: '#E6EAEE',
                                    borderRadius: '10px',
                                    // padding: '1rem',
                                    width: '100%',
                                    maxWidth: '370px',
                                    cursor: 'pointer',
                                    ":hover": {
                                        background: '#002460',
                                        boxShadow: 'rgba(0, 0, 0, 0.15) 6.95px 5.95px 4.6px'
                                    }
                                }}
                            >
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} onClick={() => handleCourseClick(item)}>
                                    <img src={item?.logo ? endpointsUrl + item?.logo : "img/folder-2.png"} style={{ width: "100%", borderRadius: "10px", padding: "10px", height: "max-content", minHeight: "150px" }} />
                                </Box>
                            </Stack>
                        </Stack>
                    )
                })
            }
        </div>
    )
}

export default TestSeriesSection